// extracted by mini-css-extract-plugin
export var table = "_u9-0";